__turbopack_context__.v({
  "average": "PortalReviewFilters-module__25uq0a__average",
  "bar": "PortalReviewFilters-module__25uq0a__bar",
  "checkbox": "PortalReviewFilters-module__25uq0a__checkbox",
  "count": "PortalReviewFilters-module__25uq0a__count",
  "filter": "PortalReviewFilters-module__25uq0a__filter",
  "filters": "PortalReviewFilters-module__25uq0a__filters",
  "panel": "PortalReviewFilters-module__25uq0a__panel",
  "rating": "PortalReviewFilters-module__25uq0a__rating",
  "ratingCount": "PortalReviewFilters-module__25uq0a__ratingCount",
  "reset": "PortalReviewFilters-module__25uq0a__reset",
  "summary": "PortalReviewFilters-module__25uq0a__summary",
  "summaryDetails": "PortalReviewFilters-module__25uq0a__summaryDetails",
  "visuallyHidden": "PortalReviewFilters-module__25uq0a__visuallyHidden",
});
